<template>
<v-container fluid>


    <v-data-iterator
      :items="items"
      :items-per-page.sync="itemsPerPage"
      no-data-text=""
      :custom-sort="customSort"
      :sort-by="sortBy"
      :sort-desc.sync="sortDesc"

      :search="search_field_text"
    >
      <template v-slot:header>

        <v-toolbar extended flat color="transparent">
          <div class="title">My Shuttles</div>
        </v-toolbar>
          <v-toolbar
            color="transparent"
            class="mb-1"
            flat
            dense

          >
            <v-text-field
              solo
              v-model="search_field_text"
              clearable
              color="green"
              prepend-inner-icon="mdi-magnify"
              label="Search"
            ></v-text-field>
            <template v-if="$vuetify.breakpoint.mdAndUp">
              <v-spacer></v-spacer>
              <template v-if="$vuetify.breakpoint.mdAndUp">
                <div style="width:425px;">
                  <v-select
                    v-model="sortBy"
                    :items="keys"
                    item-text="name"
                    item-value="value"
                    prepend-inner-icon="mdi-sort"
                    label="Sort by"
                    solo
                  ></v-select>
                </div>
                <v-btn-toggle
                  v-model="sortDesc"
                  mandatory
                  class="mx-1 mb-3"
                >
                  <v-btn
                    small
                    depressed
                    color="#0fbc5d"
                    :value="false"
                  >
                    <v-icon>mdi-arrow-up</v-icon>
                  </v-btn>
                  <v-btn
                    small
                    depressed
                    color="#0fbc5d"
                    :value="true"
                  >
                    <v-icon>mdi-arrow-down</v-icon>
                  </v-btn>
                </v-btn-toggle>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" class="ml-6 mr-8 mb-3" v-on="on" text x-large icon @click="is_list_view = !is_list_view">
                      <v-icon v-if="is_list_view">mdi-view-grid</v-icon>
                      <v-icon v-else>mdi-view-list</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ is_list_view ? "Show Grid" : "Show List" }}</span>
                </v-tooltip>
              </template>
            </template>
          </v-toolbar>
        </template>

<!--

        <v-container class="mb-0 pb-0">
          <v-row justify="end">
            <v-toolbar dense flat color="transparent">
                <v-toolbar-title>
                  My Shuttles
                </v-toolbar-title>




                <v-spacer></v-spacer>

                <v-toolbar-items>


                    <v-text-field class="mt-3"
                      style="width:325px;"
                      v-model="search_field_text"

                      rounded
                      filled
                      dense
                      color="rgba(0,0,0,0.87)"
                      @click:append="closeSearch"
                      append-icon="mdi-close"
                      v-if="show_search"
                    >

                    </v-text-field>




                      <v-btn icon text v-if="!show_search" @click="show_search = !show_search">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>







                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" text icon @click="is_list_view = !is_list_view">
                      <v-icon v-if="is_list_view">mdi-view-grid</v-icon>
                      <v-icon v-else>mdi-view-list</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ is_list_view ? "Show Grid" : "Show List" }}</span>
                </v-tooltip>


                </v-toolbar-items>

              </v-toolbar>
            </v-row>
        </v-container>

      </template>
-->
      <template v-slot:default="props">
        <v-container>


           <v-row v-if="loading">
          <v-col cols="3">
    <v-skeleton-loader 

      class="mx-auto"

      type="card"
    ></v-skeleton-loader>
          </v-col>
          <v-col cols="3">
    <v-skeleton-loader 

      class="mx-auto"

      type="card"
    ></v-skeleton-loader>
          </v-col>
                    <v-col cols="3">
    <v-skeleton-loader 

      class="mx-auto"

      type="card"
    ></v-skeleton-loader>
          </v-col>
                    <v-col cols="3">
    <v-skeleton-loader 

      class="mx-auto"

      type="card"
    ></v-skeleton-loader>
          </v-col>
        </v-row>


        <!--//
        <v-row :justify="is_list_view ? 'center' : ''">
        //-->

        <v-row>
          <v-col
            cols="12"
            :md="is_list_view ? 12 : 3"
            :sm="is_list_view ? 12 : 6"
          >

          <v-hover
          v-slot:default="{ hover }"
          open-delay="500"


        >
  <v-card
      :elevation="hover ? 6 : 2"
      style="border-radius:5px;opacity:0.66;"
      @click="creatNewShuttle();"
      v-show="!is_list_view"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="caption"></v-list-item-title>
        <v-list-item-subtitle class="caption"></v-list-item-subtitle>

      </v-list-item-content>
    </v-list-item>


    <v-img
      height="150"
    ></v-img>


<v-card-actions><v-btn text>+   Create New Shuttle</v-btn></v-card-actions>

  </v-card>
</v-hover>
</v-col>

          <v-col
            v-for="(item, itemidx) in props.items"
            :key="itemidx"
            cols="12"
            class="ma-0 pa-0"
            :md="is_list_view ? 12 : 3"
            :sm="is_list_view ? 12 : 6"
          >

          <v-divider v-if="is_list_view" class="mb-2 ma-2"></v-divider>
          <v-hover
            v-slot:default="{ hover }"
            open-delay="500"
            v-show="is_list_view"
          >

          <v-card class="mx-2" text :elevation="hover ? 2 : 0">
          <v-list-item>
          <v-list-item-avatar tile style="height:87px;width:85px;">
            <v-img
              height="100%"
              width="100%"
              :src="getPosterImage(item)"
            >
            <template v-slot:placeholder>
              <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                <v-progress-circular v-if="getPosterImage(item) != null" indeterminate color="grey"></v-progress-circular>
              </v-row>
            </template>
          </v-img>

          </v-list-item-avatar>


          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
            <v-list-item-subtitle v-text="item.video == 'EMPTY' ? '<No Upload File>' : item.video"></v-list-item-subtitle>

            <span class="caption">{{hover ? item.description : handleOverflow(item.description, 50)}}</span>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn rounded :disabled="item.video == 'EMPTY'" class="ma-2"   outlined color="primary" x-small @click="previewShuttle(item.id)">
             <v-icon left>mdi-television-play</v-icon> Preview
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn rounded class="ma-2" outlined x-small color="secondary" @click="editShuttle(item.id)">
              <v-icon left>mdi-monitor-edit</v-icon> Edit
            </v-btn>
                <v-btn  rounded v-if="item.analytics"  class="ma-2"  outlined x-small>
              <v-icon left>mdi-chart-timeline-variant</v-icon> Analytics
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-card>
      </v-hover>


          <v-hover
          v-slot:default="{ hover }"
          open-delay="500"
          v-show="!is_list_view"

        >
  <v-card
      :elevation="hover ? 6 : 2"
      style="border-radius:5px;"
      class="ma-3"
  >





    <v-img
      :src="getPosterImage(item)"
      height="138"
    >
      <template v-slot:placeholder>
        <v-row
            class="fill-height ma-0"
            align="center"
            justify="center"
          >
          <v-progress-circular v-if="getPosterImage(item) != null" indeterminate color="grey"></v-progress-circular>
        </v-row>
      </template>
    </v-img>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="caption"><b>{{item.title}}</b></v-list-item-title>
        <v-list-item-subtitle class="caption"></v-list-item-subtitle>
        <v-list-item-subtitle class="caption" style="height:22px;"><span v-if="item.description != null">{{hover ? item.description : handleOverflow(item.description, 50)}}
        </span></v-list-item-subtitle>
      <!--<v-list-item-subtitle class="caption">{{item.createdOn}}</v-list-item-subtitle>-->
      </v-list-item-content>
    </v-list-item>


    <v-card-actions>




    <v-btn class="ma-2" color="secondary" tile outlined x-small @click="editShuttle(item.id)">
      <v-icon left>mdi-monitor-edit</v-icon> Edit
    </v-btn>
        <v-btn v-if="item.analytics"  class="ma-2" tile outlined x-small>
      <v-icon left>mdi-chart-timeline-variant</v-icon> Analytics
    </v-btn>
    <v-btn v-if="item.video != 'EMPTY'" class="ma-2" tile  outlined color="primary" x-small @click="previewShuttle(item.id)">
     <v-icon left>mdi-television-play</v-icon> Preview
    </v-btn>

    </v-card-actions>
  </v-card>
</v-hover>
          </v-col>
        </v-row>
      </v-container>
      </template>

    </v-data-iterator>




</v-container>
</template>





<!--

//-->


<script>
  import { v4 as uuidv4 } from 'uuid';
  import ShuttleMixins from '@/mixins/ShuttleMixins.js';

export default {
  name: 'ShuttleList',
  mixins:[ShuttleMixins],
  data() {
    return {
      search_field_text: this.$store.state.currentSearchTerm !== '' ? this.$store.state.currentSearchTerm:'',
      show_search: false,
      is_list_view: false,
    	add_dialog:false,
    	drawer:true,
    	itemsPerPage: 15,
      shuttle_id:'',
      keys: [
        { name: 'Create Date', value: 'createdOn' },
        { name: 'Last Modified Date', value: 'lastModifiedTimeStamp' },
        { name: 'Title', value: 'title' },
        { name: 'Duration', value: 'duration' }
      ],
    	items:[],
      sortBy: 'lastModifiedTimeStamp',
      sortDesc: true,
      loading:true


    }
  },

watch:{

  search_field_text(){
			this.$store.commit('currentSearchTerm', this.search_field_text);
	},

},

  methods: {

    closeSearch() {

      //this.search_field_text = "";
      this.show_search = !this.show_search;

    },

    handleOverflow(desc_text, char_count) {
      if (desc_text != null) {
        if (desc_text.length < char_count) { return desc_text; }
        else {
          return desc_text.slice(0, char_count) + '...';
        }
      } else {
        return '';
      }
    },


      getPosterImage(item){

          var postimg = item.video_poster_image;
          ////console.log(postimg)
          return postimg

      },




  		playShuttle(id){
  				this.$router.push({path:'/play/' +id});

  		},
      listWebinar(id){
          this.$router.push({path:'/studio/webinar'});

      },

      creatNewShuttle() {
          this.shuttle_id = uuidv4();
          var newshuttle = {
              customer_id:this.$store.state.dynamo.customer_id,
              id:this.shuttle_id,
              title:'EMPTY',
              video:'EMPTY',
              video_status:'EMPTY',
              transcript:'EMPTY',
              transcript_status:'EMPTY'
          };


          this.$router.push({path:'/studio/edit/' + this.shuttle_id});
      },

      customSort(items, index, isDesc) {
        console.log(this.sortBy, this.sortDesc);
        items.sort((a, b) => {
            if (!this.sortDesc) {
              if (!b[this.sortBy]) return 1;
              if (!a[this.sortBy]) return -1;

              if (a[this.sortBy] > b[this.sortBy]) return 1
              else if (a[this.sortBy] < b[this.sortBy]) return -1;
              else return 0;
            } else {
              if (!a[this.sortBy]) return 1;
              if (!b[this.sortBy]) return -1;

              if (b[this.sortBy] > a[this.sortBy]) return 1
              else if (b[this.sortBy] < a[this.sortBy]) return -1;
              else return 0;
            }
        });
        return items;
      },

      async getShuttles() {

          //var json = await this.getUserShuttles();
          this.loading = true;
          console.log('get shuttles');
            this.$store.commit('dynamo', await this.getUserShuttles());



          let myshuttles = this.$store.state.dynamo.shuttles;

          this.items = [];
          if (myshuttles) {
              this.items = myshuttles.filter(x=>x.id != 'EMPTY');

          } else {

          }
          this.loading = false;





      },

      editShuttle(id){

          this.$router.push({path:'/studio/edit/' + id});

      }


  },


  mounted() {

      this.getShuttles();
  },



}
</script>
